import QualityReportApp from './QualityReportApp.vue'
import QualityReportSiteSetting from './pages/QualityReportSiteSetting.vue'
import QualityReportSchedule from './pages/QualityReportSchedule.vue'
import QualityReportForm from './pages/QualityReportForm.vue'
import QualityReportMine from './pages/QualityReportMine.vue'

export default {
  path: '/QualityReport',
  component: QualityReportApp,
  children: [
    {
      // 実施（作業員向け。最初は自分の担当のカード一覧。実施中が先頭・「実施する」で報告書画面へ）
      path: '/QualityReportMine',
      name: 'QualityReportMine',
      component: QualityReportMine,
      meta: { requiresAuth: true, title: 'クオリティレポート 実施' },
      props: true
    },
    {
      // 報告書（現地の実施画面。?id=tbl_quality_report.id。1 枚のカード＝1 箇所・撮った瞬間に保存・評価・完了）
      path: '/QualityReportForm',
      name: 'QualityReportForm',
      component: QualityReportForm,
      meta: { requiresAuth: true, title: 'クオリティレポート 報告書' },
      props: true
    },
    {
      // 予定・結果（進捗＝月ごとの予定日・担当者・結果・地図、スタッフごと＝担当者ごとの件数）
      path: '/QualityReportSchedule',
      name: 'QualityReportSchedule',
      component: QualityReportSchedule,
      meta: { requiresAuth: true, title: 'クオリティレポート 予定・結果' },
      props: true
    },
    {
      // 対象物件と、物件ごとの撮影設定（契約枚数・実施日・撮影する箇所）
      path: '/QualityReportSiteSetting',
      name: 'QualityReportSiteSetting',
      component: QualityReportSiteSetting,
      meta: { requiresAuth: true, title: 'クオリティレポート マスタ' },
      props: true
    },
  ]
}
